<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Ingrediensrad
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Enskild ingrediens i receptets ingredienspanel (desktop) och i
      steg-callout (mobil). Komponenten
      <span
        class="font-mono text-[13px] bg-[#f2f4f6] px-1.5 py-0.5 rounded-[5px]"
        >IngredientItem.vue</span
      >
      visar namn till vänster och mängd/enhet till höger. Varannan rad är lätt
      tonad via hover-state.
    </p>

    <!-- Lista med ingredienser -->
    <PreviewFull label="Ingredienslista">
      <div
        class="w-full max-w-[360px] rounded-xl overflow-hidden border border-[#eceef0]"
      >
        <!-- Group header -->
        <div class="px-3 pt-3 pb-1">
          <p
            class="font-[Poppins] font-bold text-[11px] text-[#6c7a77] tracking-[1px] uppercase m-0"
          >
            Deg
          </p>
        </div>
        <!-- Ingredient rows -->
        <div
          v-for="(item, i) in ingredients"
          :key="i"
          class="flex justify-between items-center py-1.5 px-3 rounded-md text-sm transition-colors"
          :class="hoveredIndex === i ? 'bg-muted/50' : ''"
          @mouseenter="hoveredIndex = i"
          @mouseleave="hoveredIndex = -1"
        >
          <span class="grow text-[#191c1e]">{{ item.name }}</span>
          <span class="text-muted-foreground shrink-0 ml-4"
            >{{ item.amount }} {{ item.unit }}</span
          >
        </div>
      </div>
    </PreviewFull>

    <!-- Single row closeup -->
    <PreviewBox label="Enskild rad">
      <div class="w-full max-w-[360px]">
        <div
          class="flex justify-between items-center py-1.5 px-3 rounded-md bg-muted/50 text-sm"
        >
          <span class="grow text-[#191c1e]">Vetemjöl</span>
          <span class="text-muted-foreground shrink-0 ml-4">500 gram</span>
        </div>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import PreviewFull from "../components/PreviewFull.vue";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const hoveredIndex = ref(-1);

const ingredients = [
  { name: "Vetemjöl", amount: "500", unit: "gram" },
  { name: "Vatten", amount: "360", unit: "ml" },
  { name: "Aktiv surdeg", amount: "100", unit: "gram" },
  { name: "Salt", amount: "10", unit: "gram" },
];

const htmlCode = `<!-- components/recipe/IngredientItem.vue -->
<IngredientItem :ingredient="ingredient" />

<!-- ingredient-objektets form -->
<!-- { id, name, amount, amount_type } -->
<!-- amount_type: gram | kg | ml | dl | liter | tsk | msk | st -->

<!-- Intern mall i IngredientItem.vue -->
<div
  class="flex justify-between items-center py-1.5 px-3 rounded-md hover:bg-muted/50 transition-colors text-sm"
>
  <span class="grow">{{ ingredient.name }}</span>
  <span class="text-muted-foreground shrink-0 ml-4">
    {{ formatAmount(ingredient.amount) }} {{ ingredient.amount_type }}
  </span>
</div>`;

const cssCode = `/* Rad */
display: flex;
justify-content: space-between;
align-items: center;
padding: 6px 12px;       /* py-1.5 px-3 */
border-radius: 6px;      /* rounded-md */
font-size: 14px;         /* text-sm */
transition: background-color 150ms;

/* Hover-state */
background: hsl(var(--muted) / 0.5);   /* bg-muted/50 */

/* Ingrediensnamn (vänster) */
flex: 1 1 auto;
color: #191c1e;

/* Mängd + enhet (höger) */
flex-shrink: 0;
margin-left: 16px;       /* ml-4 */
color: hsl(var(--muted-foreground));   /* text-muted-foreground */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
